<template>
  <div class='view-contents'>
    <div class="row title-row">
      <div class="col section-title">
        Export Bills
      </div>
    </div>
    <div class="section-header">
    </div>
    <div class="mid-page-section-header normal-title">
      Bills Approved for Payment
      <b-button
        pill size="sm"
        variant="primary"
        class="float-right-button action-button"
        @click="markAsPaid"
        :disabled="selectedBillIds.length < 1"
      >
        <span>Mark Selected Bills as Paid</span>
      </b-button>
      <b-button
        pill size="sm"
        variant="primary"
        class="float-right-button action-button"
        @click="exportBills"
        :disabled="selectedBillIds.length < 1"
      >
        <span>Export Selected Bills</span>
      </b-button>
    </div>
    <LoadingSpinner size = '2x' v-if='loadingBills' />
    <LoadingSpinner size = '2x' v-else-if='downloadingBills' message='Downloading Bills' />
    <LoadingSpinner size = '2x' v-else-if='updatingBills' message='Updating Records' />
    <template v-else >
      <b-form-checkbox-group
        id="checkbox-group-2"
        v-model="selectedBillIds"
        name="flavour-2"
      >
        <b-table
          id="export-bills-table"
          bordered
          hover
          ref="export-bills-table"
          head-variant="light"
          :fields="fields"
          :items="approvedWorkOrderBills"
          class="list-item-table"
          show-empty>
          <template v-slot:cell(invoiceNumber)="row">
            <b-link
              :to="{ name: 'ProjectWorkorderBillDrilldown',
              params: {
                id: row.item.projectId,
                workorderId: row.item.workOrderId,
                billId: row.item.projectId
              } }">
              {{ row.item.invoiceNumber }}
            </b-link>
          </template>
          <template v-slot:cell(selectBox)="row">
            <b-form-checkbox :value=row.item.id></b-form-checkbox>
          </template>
        </b-table>
      </b-form-checkbox-group>
      <b-button
        pill size="sm"
        variant="primary"
        class="action-button"
        @click="selectAllIds"
      >
        <span>Select All</span>
      </b-button>
      <b-button
        pill
        size="sm"
        variant="danger"
        class="action-button"
        @click="unselectAllIds"
      >
        <span>Clear Selection</span>
      </b-button>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'ExportBills',
  components: {
    LoadingSpinner,
  },
  mounted() {
    this.$store.dispatch('WorkorderBill/getWorkorderBillsApprovedForPayment');
  },
  computed: {
    ...mapState('WorkorderBill', {
      loadingBills: (state) => state.loadingBills,
      downloadingBills: (state) => state.downloadingBills,
      updatingBills: (state) => state.updatingBills,
      serverError: (state) => state.serverError,
      workorderBillsApprovedForPayment: (state) => state.workorderBillsApprovedForPayment,
    }),
    ...mapGetters('WorkorderBill', [
      'approvedWorkOrderBills',
    ]),
  },
  data() {
    return {
      selectedBillIds: [],
      fields: [
        {
          key: 'selectBox',
          label: 'Select',
          class: 'action-column',
        },
        {
          key: 'invoiceNumber',
          label: 'Invoice Number',
          class: 'text-column',
        },
        {
          key: 'projectName',
          label: 'Project Name',
          class: 'text-column',
        },
        {
          key: 'projectManager',
          label: 'Project Manager',
          class: 'text-column',
        },
        {
          key: 'workOrderNumber',
          label: 'Work Order Number',
          class: 'text-column',
        },
        {
          key: 'vendor',
          label: 'Vendor',
          class: 'text-column',
        },
        {
          key: 'receivedDate',
          label: 'Received Date',
          formatter: (value) => {
            let newVal = value;
            if (typeof value === 'string') {
              newVal = new Date(value);
            }
            return newVal ? newVal.toLocaleDateString('en-US', { type: 'short' }) : null;
          },
          class: 'date-column',
        },
      ],
    };
  },
  methods: {
    selectAllIds() {
      this.selectedBillIds = this.approvedWorkOrderBills.map((bill) => bill.id);
    },
    unselectAllIds() {
      this.selectedBillIds = [];
    },
    markAsPaid() {
      this.$store.dispatch('WorkorderBill/markBillsAsPaid', this.selectedBillIds);
      if (!this.serverError || this.serverError === '') {
        window.location.href = `mailto:${this.selectedBillsEmails()}?subject=Bill(s) Paid&body=${this.emailBody()}`;
      }
    },
    exportBills() {
      return this.$store.dispatch('WorkorderBill/downloadBills', this.selectedBillIds);
    },
    selectedBillsEmails() {
      return this.selectedBills().map((bill) => bill.projectManagerEmail).join(';');
    },
    emailBody() {
      return encodeURIComponent(this.selectedBills()
        .map((bill) => `${bill.projectName}: ${this.workorderHref(bill)}`)
        .join('\n'));
    },
    workorderHref(bill) {
      return `${window.location.href.slice(0, window.location.href.lastIndexOf('/'))}/project/${bill.projectId}/workorders/${bill.workOrderId}/bill/${bill.id}`;
    },
    selectedBills() {
      if (this.selectedBillIds) {
        return this.approvedWorkOrderBills
          .filter((bill) => this.selectedBillIds.includes(bill.id));
      }
      return [];
    },
  },
};
</script>
